import { render } from "./TotalsChart.vue?vue&type=template&id=60c1de32"
import script from "./TotalsChart.vue?vue&type=script&lang=js"
export * from "./TotalsChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__